// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3h86L","paramInput":"JobSimulator_paramInput__1pj8-","input":"JobSimulator_input__26s0n"};